/* Atelier Intim: "Setul zilei" (countdown + two-variant add) and product share (copy link). No dependencies. */
(function () {
  'use strict';
  var timers = new WeakMap();

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }

  function expire(root) {
    root.querySelectorAll('[data-sf-offer-body],[data-sf-offer-items]').forEach(function (el) { el.hidden = true; });
    var order = root.querySelector('[data-sf-offer-order]');
    if (order) order.remove(); /* CTA and promo price (inside body) are gone; nothing can be added any more */
    var ended = root.querySelector('[data-sf-offer-ended]');
    if (ended) ended.hidden = false;
    root.classList.add('is-ended');
  }

  function setStatus(root, text, withCartLink) {
    var status = root.querySelector('[data-sf-offer-status]');
    if (!status) return;
    status.textContent = text;
    if (withCartLink) {
      var a = document.createElement('a');
      a.href = cartUrl();
      a.textContent = 'Deschide coșul';
      status.appendChild(document.createTextNode(' '));
      status.appendChild(a);
    }
  }

  function initOffer(root) {
    if (timers.has(root)) return;
    var end = Date.parse(root.getAttribute('data-end'));
    if (isNaN(end) || end <= Date.now()) { expire(root); return; }
    var d = root.querySelector('[data-sf-d]'), h = root.querySelector('[data-sf-h]'),
        m = root.querySelector('[data-sf-m]'), s = root.querySelector('[data-sf-s]'),
        timer = root.querySelector('[data-sf-timer]'), lastMinute = -1, interval = null;

    function tick() {
      if (!root.isConnected) { stop(); return; }
      var left = end - Date.now(); /* absolute deadline: never resets */
      if (left <= 0) { stop(); expire(root); return; }
      var total = Math.floor(left / 1000);
      var days = Math.floor(total / 86400), hrs = Math.floor(total / 3600) % 24, mins = Math.floor(total / 60) % 60;
      if (d) d.textContent = String(days);
      if (h) h.textContent = pad(hrs);
      if (m) m.textContent = pad(mins);
      if (s) s.textContent = pad(total % 60);
      /* One overall label, refreshed only once per minute (no per-second announcements). */
      var minuteKey = Math.floor(total / 60);
      if (timer && minuteKey !== lastMinute) {
        lastMinute = minuteKey;
        timer.setAttribute('aria-label', 'Timp rămas până la sfârșitul ofertei: ' + days + ' zile, ' + hrs + ' ore, ' + mins + ' minute');
      }
    }
    function start() { if (interval === null) { tick(); if (root.isConnected && !root.classList.contains('is-ended')) interval = setInterval(tick, 1000); } }
    function stop() { if (interval !== null) { clearInterval(interval); interval = null; } }
    function onVisibility() { if (document.hidden) stop(); else if (root.isConnected) start(); }

    var button = root.querySelector('[data-sf-offer-add]');
    var onClick = null;
    var navigationSucceeded = false;
    if (button) {
      onClick = function () {
        if (button.disabled) return;
        if (Date.now() >= end) { stop(); expire(root); return; } /* deadline checked before the request */
        var ids = (root.getAttribute('data-variants') || '').split(',').filter(Boolean);
        if (ids.length !== 2) return;
        button.disabled = true;
        setStatus(root, 'Se adaugă produsele…', false);
        var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
        if (!/\.js$/.test(base)) base += '.js';
        fetch(base, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
        }).then(function (response) {
          if (response.ok) { navigationSucceeded = true; window.location.assign(cartUrl()); return; }
          button.disabled = false; /* no automatic retry; the customer decides */
          setStatus(root, 'Nu am putut adăuga setul. Verifică coșul înainte de a reîncerca.', true);
        }, function () {
          button.disabled = false;
          setStatus(root, 'Conexiunea a eșuat și nu știm dacă produsele au fost adăugate. Verifică coșul înainte de a reîncerca.', true);
        });
      };
      button.addEventListener('click', onClick);
    }

    function onPageShow(event) {
      if (!event.persisted) return;
      if (Date.now() >= end) { stop(); expire(root); return; }
      if (navigationSucceeded && button) { button.disabled = false; navigationSucceeded = false; setStatus(root, '', false); }
      start();
    }
    window.addEventListener('pageshow', onPageShow);
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('pagehide', stop);
    timers.set(root, function () {
      stop();
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('pagehide', stop);
      window.removeEventListener('pageshow', onPageShow);
      if (button && onClick) button.removeEventListener('click', onClick);
      timers.delete(root);
    });
    start();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-sf-offer]').forEach(initOffer);
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve, reject) {
      var input = document.createElement('input');
      input.value = text; input.setAttribute('readonly', ''); input.style.position = 'fixed'; input.style.opacity = '0';
      document.body.appendChild(input); input.select();
      try { document.execCommand('copy') ? resolve() : reject(); } catch (e) { reject(e); }
      input.remove();
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-sf-copy]');
    if (!button) return;
    var box = button.closest('[data-sf-share]');
    var status = box && box.querySelector('[data-sf-copy-status]');
    var text = button.querySelector('[data-sf-copy-text]');
    copyText(button.getAttribute('data-sf-copy')).then(function () {
      if (status) status.textContent = 'Linkul a fost copiat.';
      if (text) { var old = text.getAttribute('data-original') || text.textContent; text.setAttribute('data-original', old); text.textContent = 'Link copiat'; setTimeout(function () { text.textContent = old; }, 2500); }
    }, function () {
      if (status) status.textContent = 'Nu am putut copia linkul. Îl poți copia din bara de adrese.';
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-sf-offer]').forEach(function (root) { var off = timers.get(root); if (off) off(); });
  });
})();
